import pushService from '../services/pushService';
import { limparSessaoLocal } from './auth';
import { obterInscricaoPushLocal } from './serviceWorker';

/**
 * Encerra a sessão do usuário.
 *
 * Antes de apagar o token, remove a inscrição Web Push deste navegador no
 * backend. Assim o próximo usuário do mesmo dispositivo não recebe avisos do
 * usuário anterior. A remoção é best-effort: falhas nunca bloqueiam o logout.
 */
export const encerrarSessao = async ({ removerPush = true } = {}) => {
  const tokenInicial = localStorage.getItem('token');

  if (removerPush) {
    const remover = async () => {
      try {
        const subscription = await obterInscricaoPushLocal();

        if (!subscription) return;

        try {
          await pushService.remover(subscription.endpoint);
        } catch {
          // Token já expirado/revogado: a inscrição órfã será removida pelo
          // backend no primeiro envio (410) ou pelo próximo subscribe.
        }

        try {
          await subscription.unsubscribe();
        } catch {
          // Ignora navegadores que não permitem cancelar no unload.
        }
      } catch {
        // Service worker indisponível: segue com o logout normal.
      }
    };

    // Não deixa o logout preso esperando registro/API de push.
    await Promise.race([
      remover(),
      new Promise((resolve) => {
        setTimeout(resolve, 1500);
      }),
    ]);
  }

  // Se outra aba/login criou uma sessão nova durante a limpeza, não a apaga.
  if (localStorage.getItem('token') === tokenInicial) {
    limparSessaoLocal();
  }
};

export default encerrarSessao;
